import React from 'react';
import { ContentfulRichText } from 'common/components';
import Checkbox from 'public/components/ModularComponents/Checkbox';

export default function CheckboxInput({ input, handleInputChange, value }) {
  const { name, checkboxContent } = input.fields;

  return (
    <Checkbox
      name={name}
      checked={value}
      label={<ContentfulRichText field={{ 'en-US': checkboxContent }} />}
      onChange={(e) =>
        handleInputChange({ ...input.fields, value: e.target.checked })
      }
    />
  );
}
